export const VERIFIED_STATUSES = [
  'kyc_pre_verified',
  'kyc_verified',
  'kyc_oy_verified',
  'kyc_lkd_verified',
  'approved',
];

export const NEED_VERIFICATION_STATUSES = [
  'unauthorized',
  'new',
  'pending',
  'in_progress',
  'waiting_confirmation',
];

export const REJECTED_STATUSES = ['kyc_rejected'];

export const SUBMITTED_STATUSES = ['kyc_submitted'];

export const TRIAL_STATUSES = ['trial'];

export const AFTER_TRIAL_STATUSES = ['after_trial'];

// For this moment, 'rejected' is treated as blacklisted
// TODO: need to be updated when there is proper blaclisted status
export const BLACKLISTED_STATUSES = ['rejected'];
